const tournaments = {
    "LBL_PAGE_TITLE":"Турниры"
};
export default tournaments;